import { createFileRoute } from '@tanstack/react-router'
import { HomeFeature } from '@/features/home/HomeFeature'

export const Route = createFileRoute('/')({
  component: HomePage,
})

function HomePage() {
  return <HomeFeature />
}
